<div [formGroup]="formGroup">
    <mat-form-field appearance="outline" class="w-100">
        <mat-label>Background Type</mat-label>
        <mat-select id="backgroundType" name="backgroundType" formControlName="backgroundType">
            <mat-option [value]="'halfBackground'">Half background</mat-option>
            <mat-option [value]="'fillBackground'">Fill background</mat-option>
        </mat-select>
    </mat-form-field>

    <h5 class="mt-3">Add background images</h5>
    <div class="mb-3 d-flex align-items-center">
        <mat-slide-toggle id="remove-shadow-toggle" [formControl]="effectiveRemoveShadowControl">
            Remove shadow
        </mat-slide-toggle>
    </div>
    <div formArrayName="backgroundImages">
        @for (backgroundImage of backgroundImages?.controls; track backgroundImage; let i = $index) {
            <div class="row align-items-center m-3" [formGroup]="backgroundImage">
                <div class="col-5">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Backgound images</mat-label>
                        <input matInput [id]="getUniqueId('background-img-input', i)" formControlName="name" />
                    </mat-form-field>
                </div>

                <div class="col-6 d-flex align-items-center">
                    @if (!isUploadingBackgroundImg || i !== uploadingIndex) {
                        <input
                            class="m-3"
                            type="file"
                            [id]="getUniqueId('background-img-file', i)"
                            (change)="onFileSelected($event, 'backgroundImg', i)"
                            accept=".svg,.png,.jpg"
                        />
                    }
                    @if (isUploadingBackgroundImg && i === uploadingIndex) {
                        <mat-progress-spinner
                            class="m-3"
                            [id]="getUniqueId('background-img-spinner', i)"
                            diameter="30"
                            mode="indeterminate"
                        ></mat-progress-spinner>
                    }
                </div>

                @if (!$first) {
                    <div class="col-1 d-flex align-items-center">
                        <button
                            class="dynamic-field-form-delete delete-btn"
                            mat-icon-button
                            type="button"
                            class="me-2"
                            (click)="delete(i)"
                            [id]="getUniqueId('delete-btn', i)"
                        >
                            <mat-icon>delete</mat-icon>
                        </button>
                    </div>
                }
            </div>
        }
    </div>

    <div class="text-center">
        <button
            type="button"
            mat-stroked-button
            id="add-background-image-field"
            class="mt-2"
            (click)="addBackgroundImageField()"
        >
            Add Background Image Field
        </button>
    </div>
</div>
